/**
 * Derivações puras do herói (§7.2 bloco 3, `HeroModel`): lados na ordem do contrato [número menor, número maior]
 * (nunca pelo líder, N01), margem em pontos, diferença em votos e casas da meta. O número do TSE vem como está
 * (`view.national`, M30): nada aqui soma UFs.
 */
import type { Candidate, Decision, ResultsView } from '../../model/types';

export interface HeroSide {
  candidate: Candidate;
  /** Fração dos válidos (0–1). */
  share: number;
  votes: number;
  /** É o líder da contagem (`national.leader`); só informação, a ordem nunca muda. */
  leads: boolean;
}

export interface HeroModel {
  /** Sem votos válidos. */
  pre: boolean;
  /** Com votos e `sectionsFraction < 0,01` (números esmaecidos, §7.5). */
  early: boolean;
  /** `tseResult ?? mathDecision` (o TSE prevalece no chip). */
  decided: Decision | null;
  /** [número menor, número maior]. */
  sides: [HeroSide, HeroSide];
  /** |shares[1] − shares[0]| × 100. */
  marginPts: number;
  /** |votes[1] − votes[0]|. */
  diffVotes: number;
  /** 2 casas com `marginPts < 1`, senão 1 (rodapé da `GoalBar`, §7.6). */
  goalDecimals: 1 | 2;
}

/** §7.2 bloco 3, como no texto da especificação. */
export function heroModel(v: ResultsView): HeroModel {
  const n = v.national;
  const marginPts = Math.abs(n.shares[1] - n.shares[0]) * 100;
  const side = (i: 0 | 1): HeroSide => ({
    candidate: v.candidates[i],
    share: n.shares[i],
    votes: n.votes[i],
    leads: n.leader === i,
  });
  return {
    pre: n.validVotes === 0,
    early: n.validVotes > 0 && n.sectionsFraction < 0.01,
    decided: n.tseResult ?? n.mathDecision,
    sides: [side(0), side(1)],
    marginPts,
    diffVotes: Math.abs(n.votes[1] - n.votes[0]),
    goalDecimals: marginPts < 1 ? 2 : 1,
  };
}
